import { render, staticRenderFns } from "./footerPC.vue?vue&type=template&id=6a906015&scoped=true"
import script from "./footerPC.vue?vue&type=script&lang=js"
export * from "./footerPC.vue?vue&type=script&lang=js"
import style0 from "./footerPC.vue?vue&type=style&index=0&id=6a906015&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a906015",
  null
  
)

export default component.exports